function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 9.40234C1.66602 6.57409 1.66602 5.15959 2.54502 4.28134C3.42402 3.40309 4.83777 3.40234 7.66602 3.40234H10.666C13.4943 3.40234 14.9088 3.40234 15.787 4.28134C16.6653 5.16034 16.666 6.57409 16.666 9.40234V10.9023C16.666 13.7306 16.666 15.1451 15.787 16.0233C14.908 16.9016 13.4943 16.9023 10.666 16.9023H7.66602C4.83777 16.9023 3.42327 16.9023 2.54502 16.0233C1.66677 15.1443 1.66602 13.7306 1.66602 10.9023V9.40234Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 0.9375
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 3.40234V2.27734M12.916 3.40234V2.27734M2.04102 7.15234H16.291",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.d2942c1eadd2c512ba5dbb9d7749b448.svg";
export { ForwardRef as ReactComponent };